module.exports = __webpack_public_path__ + "static/media/LocalMapLayer.6fd6f9f7.png";